<template>
  <div>
    <small class="label">{{ $l.userPhoneNumber }}</small>
    <input
      type="text"
      class="input-text with-label"
      v-model="tel"
      :placeholder="$l.userPhoneNumber"
      >
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  computed: {
    tel: {
      get: function () {
        return this.$store.state.user.tel
      },

      set: function (tel) {
        this.$store.commit('user/setTel', tel)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './_input.scss';
</style>
